//
// Threads
//
export const DIRECT_THREAD_ID_PREFIX = 'zcstZ';
export const POST_THREAD_ID_PREFIX = 'pstZ';
export function isDirectThreadId(threadId) {
    return threadId.startsWith(DIRECT_THREAD_ID_PREFIX);
}
export function genDirectThreadId(customerId) {
    return DIRECT_THREAD_ID_PREFIX + customerId;
}
export function genPostThreadId(messageId) {
    return POST_THREAD_ID_PREFIX + messageId;
}
export function getCustomerIdFromThread(threadId) {
    return threadId.startsWith(DIRECT_THREAD_ID_PREFIX) ? threadId.slice(DIRECT_THREAD_ID_PREFIX.length) : undefined;
}
export function getPostMessageIdFromThreadId(threadId) {
    return threadId.startsWith(POST_THREAD_ID_PREFIX) ? threadId.slice(POST_THREAD_ID_PREFIX.length) : undefined;
}
//
// Channels
//
export const DIRECT_CHANNEL_ID_PREFIX = 'zcstZ';
export const BUSINESS_CHANNEL_ID_PREFIX = 'bizZ';
export function isDirectChannelId(channelId) {
    return channelId.startsWith(DIRECT_CHANNEL_ID_PREFIX);
}
export function isBusinessChannelId(channelId) {
    return channelId.startsWith(BUSINESS_CHANNEL_ID_PREFIX);
}
export function genDirectChannelId(customerId) {
    return DIRECT_CHANNEL_ID_PREFIX + customerId;
}
export function genBusinessChannelId(businessId) {
    return BUSINESS_CHANNEL_ID_PREFIX + businessId;
}
export function getCustomerIdFromChannel(channelId) {
    return channelId.startsWith(DIRECT_CHANNEL_ID_PREFIX) ? channelId.slice(DIRECT_CHANNEL_ID_PREFIX.length) : undefined;
}
export function getBusinessIdFromChannel(channelId) {
    return channelId.startsWith(BUSINESS_CHANNEL_ID_PREFIX) ? channelId.slice(BUSINESS_CHANNEL_ID_PREFIX.length) : undefined;
}
//# sourceMappingURL=channels.js.map